import apiHandler from "./../../utilities/apiHandler.js";

const CreditTransactionApiHandler = {
	getCreditTransactionConfig: function () {
		var URL = "api/credit/gateway/config";
		return apiHandler.get(URL);
	},

	getCreditTransactiipns: function (request) {
		var URL = "api/credit/gateway/fetch/credit-transactions";
		return apiHandler.post(URL, request);
	},

	getCreditTransactionDump: function (request) {
		var URL = "api/credit/gateway/dump/payment_instrument/bulk";
		return apiHandler.fileDownloadHttpPost(URL, request);
	},

	changeChequeNumber: function (request) {
		var URL = "api/credit/gateway/cheque/edit/bulk";
		return apiHandler.post(URL, request);
	}
};

export default CreditTransactionApiHandler;



// WEBPACK FOOTER //
// ./src/screens/creditTransactions/CreditTransactionApiHandler.js